module.exports = __webpack_public_path__ + "static/media/bg-header-popup-ranking.79998360.png";